import frFR from 'utils/localesAntd/fr_FR'
import enGB from 'utils/localesAntd/en_GB'
import { container } from './hoc'
import Component from './app'
import listeners from './app.listeners'

const intl = 'app'

const mapStore = (store) => {
  return {
    ready: store.ui.ready.get(),
    authorized: store.ui.authorized.get(),
    locale: store.config.lang.get() === 'en-GB' ? enGB : frFR,
    store,
  }
}

export default container({ mapStore, listeners, intl })(Component)
